import { createFileRoute, redirect } from '@tanstack/react-router';
import { PageContent } from '@/components/page-content';
import { PageHeader } from '@/components/page-header';
import { featuresOptions } from '@/hooks/query-options';
import { hasPermission } from '@/lib/permissions';
import { YourIntegrations } from '@/components/integrations-hub/your-integrations';

export const Route = createFileRoute(
  '/_auth/_side-layout/integrations/connected',
)({
  component: YourIntegrationsPage,
  beforeLoad: async ({ context }) => {
    // Direct-URL guard mirroring the nav's `integrations` flag gate.
    const features =
      await context.queryClient.ensureQueryData(featuresOptions());
    if (
      features.integrationsHub !== true ||
      !hasPermission(context.userRole, { organization: ['update'] })
    ) {
      throw redirect({ to: '/integrations/access' });
    }
  },
});

function YourIntegrationsPage() {
  return (
    <>
      <PageHeader
        title="Your Integrations"
        description="Manage the integrations your organization has connected."
      />
      <PageContent>
        <YourIntegrations />
      </PageContent>
    </>
  );
}
